import { WINDOWS_CDN_PATH } from '../../../windows-constants';

export const VEKA_BRAND_STRUCTURE = {
  title: 'brands-section.veka-title',
  description: 'brands-section.veka-description',
  detailedInfo: [
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/veka/whs_60.jpg/whs_60.jpg`,
      name: 'WHS 60 by VEKA',
      mountingWidth: '60 мм',
      numberOfCameras: '4',
      thermalInsulation: '0,77 м² ̊С/Вт',
      doubleGlazing: 'от 4 до 32 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/veka/whs_72.jpg/whs_72.jpg`,
      name: 'WHS 72 by VEKA',
      mountingWidth: '72 мм',
      numberOfCameras: '5',
      thermalInsulation: '0,92 м² ̊С/Вт',
      doubleGlazing: 'от 24 до 44 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/veka/softline_70.jpg/softline_70.jpg`,
      name: 'VEKA Softline 70',
      mountingWidth: '70 мм',
      numberOfCameras: '5',
      thermalInsulation: '0,94 м² ̊С/Вт',
      doubleGlazing: 'от 4 до 42 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/veka/softline_82.jpg/softline_82.jpg`,
      name: 'VEKA Softline 82',
      mountingWidth: '82 мм',
      numberOfCameras: '6, 7',
      thermalInsulation: '1,12 м² ̊С/Вт',
      doubleGlazing: 'от 24 до 54 мм',
    },
  ],
};
